import { Injectable } from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';
import { StorageService } from '@platform-frontend/util';

@Injectable({
  providedIn: 'root'
})
export class CustomStorageEngine implements StorageEngine {
  constructor(private storageService: StorageService) {}

  get length(): number {
    return 2;
  }

  getItem(key: string): any {
    return this.storageService.getPlainFromLocalStorage(key);
  }

  setItem(key: string, val: any): void {
    this.storageService.putInLocalStorage(key, val);
  }

  removeItem(key: string): void {
    this.storageService.removeFromLocalStorage(key);
  }

  clear(): void {
    this.storageService.clearLocalStorage();
  }
}
